import * as Immutable from "immutable";
export default class SeriesConfig {
  constructor(name, thresholds = void 0) {
    this._value = { name, thresholds };
  }
  get name() {
    return this._value.name;
  }
  get thresholds() {
    return this._value.thresholds;
  }
  toJSON() {
    const { name, thresholds } = this._value;
    return { name, thresholds };
  }
  static fromJSON(value) {
    const { name, thresholds } = value;
    return new SeriesConfig(name, thresholds);
  }
  static empty() {
    return new SeriesConfig(null, null);
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  name(newName) {
    return new Builder(this.value.set("name", newName));
  }
  thresholds(thresholds) {
    return new Builder(this.value.set("thresholds", thresholds));
  }
  build() {
    const { name, thresholds } = this.value.toObject();
    return new SeriesConfig(name, thresholds);
  }
}
